import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Wrench, ExternalLink } from 'lucide-react';

// Updated navigation with Wahle-Tec branding
const Navigation = () => {
  const location = useLocation();

  const navLinks = [{ path: '/', label: 'Tool Hub', icon: Wrench }];

  return (
    <nav className="main-nav">
      <div className="nav-content">
        <Link to="/" className="nav-title">
          Wahle-Tec Preparedness Tools Hub
        </Link>

        <div className="nav-links">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`nav-link nav-link--primary ${location.pathname === link.path ? 'active' : ''}`}
            >
              <link.icon className="nav-link-icon" size={18} />
              <span>Tool Hub</span>
            </Link>
          ))}
          <a
            href="https://wahletec.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link nav-link--outline"
          >
            <span>Wahle-Tec Website</span>
            <ExternalLink className="nav-link-icon" size={16} />
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
